
const WebIcon = ({ width = "40", height = "40", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="20"
        cy="20"
        r="19.4444"
        fill="white"
        stroke="#EDEBEC"
        strokeWidth="1.11111"
      />
      <path
        d="M27.5 15.1887C25.2201 16.5049 22.6325 17.1945 20 17.1875C17.3675 17.1945 14.7799 16.5049 12.5 15.1887"
        stroke="#0069AD"
      />
      <path
        d="M19.5 23H16.5L17 25.5L17.5 27.5L19 29H21.5L22.5 26.5L23.5 23.5L19.5 23Z"
        fill="#BBD8ED"
      />
      <path
        d="M12.5 24.83C14.7767 23.519 17.3578 22.829 19.985 22.829C22.6122 22.829 25.1933 23.519 27.47 24.83"
        stroke="#0069AD"
      />
      <path
        d="M18.875 29C16.9277 26.4036 15.875 23.2456 15.875 20C15.875 16.7544 16.9277 13.5964 18.875 11"
        stroke="#00A7E4"
      />
      <path
        d="M21.125 11C23.0723 13.5964 24.125 16.7544 24.125 20C24.125 23.2456 23.0723 26.4036 21.125 29"
        stroke="#00A7E4"
      />
      <path
        d="M20 29C24.9706 29 29 24.9706 29 20C29 15.0294 24.9706 11 20 11C15.0294 11 11 15.0294 11 20C11 24.9706 15.0294 29 20 29Z"
        stroke="#0069AD"
      />
    </svg>
  );
};

export default WebIcon;